export default "__VITE_ASSET__ChA0i_ku__"